export default {
  loading: false,
  stamp_types: [],
  totalCount: 0,
};
